// DataContext.js
import React, { createContext, useContext } from "react";

export const PropertiesData = createContext();

export function usePropertiesData() {
    return useContext(PropertiesData);
}
